import { sdkRequest } from '@eb/http';
import { eventsDuck, collectionsDuck } from '@eb/redux-destination';

import { Collection } from '../../types';

type CollectionsResponse = {
    collections: Collection[];
};

export const getCollectionsForEvent = async ({
    id,
}: {
    id: string;
}): Promise<CollectionsResponse> => {
    const results = await sdkRequest(
        `/api/v3/destination/events/${id}/?expand=my_collections`,
    );

    return results.my_collections;
};

export const saveEvent = async (id: string): Promise<{}> => {
    const response = await eventsDuck.api.saveEvent(id);

    return response;
};

export const unSaveEvent = async (id: string): Promise<{}> => {
    const response = await eventsDuck.api.unsaveEvent(id);

    return response;
};

export const createCollection = async (
    name: string,
    eventId: string,
): Promise<Collection> => {
    const response = await collectionsDuck.api.createCollection(name, [
        eventId,
    ]);

    return response;
};

export const addToCollection = async (
    collectionId: string,
    eventId: string,
): Promise<{}> => {
    const response = await collectionsDuck.api.addToCollection(
        eventId,
        collectionId,
    );

    return response;
};

export const removeFromCollection = async (
    collectionId: string,
    eventId: string,
): Promise<{}> => {
    const response = await collectionsDuck.api.removeFromCollection(
        eventId,
        collectionId,
    );

    return response;
};
